import Chip from "@mui/material/Chip";
import { useTranslation } from "i18n-fe";
import { ENTRY_METHODS, entryMethodOf } from "score-common";

// #1931 — how a sheet's marks got into it, shown wherever Score Admin
// displays a sheet's marks (AC5). Reads provenance.method through
// score-common's entryMethodOf, so a sheet with NO method (created before
// #1931, or before #2815's provenance existed at all) renders an honest
// "Entry unknown" chip — NEVER scribe-live (AC4). Pure record, no gating:
// the chip never disables or warns anything (AC8).
//
// Same posture as SheetStateChip (#587): semantic MUI colors only, static
// i18n keys (i18n-fe requires literal keys, no interpolation — #868), label
// text in scoreadmin.json. NEVER brand `primary` (dark grey, disappears on
// a dark background).
export const ENTRY_METHOD_DISPLAY = {
  [ENTRY_METHODS.SCRIBE_LIVE]: { color: "success", labelKey: "entryMethod.scribeLive" },
  [ENTRY_METHODS.ADMIN_PAPER]: { color: "info", labelKey: "entryMethod.adminPaper" },
  [ENTRY_METHODS.RECONSTRUCTED]: { color: "warning", labelKey: "entryMethod.reconstructed" },
};

export const UNKNOWN_ENTRY_METHOD_DISPLAY = {
  color: "default",
  labelKey: "entryMethod.unknown",
};

export default function EntryMethodChip({ sheet, method, size = "small", ...props }) {
  const { t } = useTranslation("scoreadmin");
  const resolved = method ?? entryMethodOf(sheet);
  const display = ENTRY_METHOD_DISPLAY[resolved] ?? UNKNOWN_ENTRY_METHOD_DISPLAY;
  return (
    <Chip
      size={size}
      color={display.color}
      label={t(display.labelKey)}
      variant={resolved ? "filled" : "outlined"}
      data-testid="entry-method-chip"
      {...props}
    />
  );
}
